import React, { useState } from 'react'; 
import CustomerDashboard from "./CustomerDashboard";
import EmployeeDashboard from "./EmployeeDashboard";
import { useMountEffect } from 'primereact/hooks';
import StorageHelper from '../../../utils/storage-helper';

const DynamicDashboard = () => { 
  const [userType, setuserType] = useState('');
  useMountEffect(() => {
    const fetchUserRole = async () => {
      try { 
        setuserType(StorageHelper.get('userType')); 
      } catch (error) {
        console.error('Error fetching user userRole:', error);
      }
    };
    fetchUserRole();
  }, []);

  return (
    <>
      {userType === "CUSTOMER" ? (<CustomerDashboard />) : (<EmployeeDashboard />)}
    </>);
};


export default DynamicDashboard;

